import * as R from 'ramda';

export const arrayHelper = {
    singleToArray<T>(singleOrArr: T | T[]) {
        return ([] as T[]).concat(singleOrArr);
    },

    getListWithInsertedItem<T>({
        list,
        item,
        idKey = 'id',
        idKeys = [idKey],
    }: {
        list: T[];
        item: T;
        idKey?: string;
        idKeys?: string[];
    }) {
        list = [...list];
        const index = list.findIndex((listItem) => {
            return idKeys.every((key) => listItem[key] === item[key]);
        });

        if (index === -1) {
            list = [...list, item];
        } else {
            list[index] = { ...item };
        }

        return list;
    },
    getListWithoutItem<T>({
        list,
        item,
        id,
        idKey = 'id',
    }: {
        list: T[];
        item: T;
        id: string;
        idKey?: string;
    }) {
        return list.filter(
            (listItem) => listItem[idKey] !== (id || item[idKey]),
        );
    },
    sortVersions<T>(
        versions: T[],
        { isDescending }: { isDescending?: boolean } = {},
    ) {
        return versions
            .map(_convertVersionToFixed)
            .sort((a, b) => {
                if (a < b) {
                    return isDescending ? 1 : -1;
                }
                return isDescending ? -1 : 1;
            })
            .map(_convertVersionFromFixed) as T[];
    },
    listToObject<T>(list: T[], keys: string[]) {
        return list.reduce(
            (acc, item, index) => ({
                ...acc,
                [keys[index]]: item,
            }),
            {},
        );
    },

    getArrayOfSize<T>(
        n: number | string,
        filler: (() => T) | T | undefined = undefined,
    ): T[] {
        const arr = new Array(Number(n));
        arr.fill(filler);
        if (typeof filler === 'function') {
            return arr.map(filler as () => T);
        }
        return arr;
    },

    sortWithOrderedPredicates<T>(
        items: T[],
        orderedPredicates: ((arg: T) => boolean)[],
    ): T[] {
        const { sorted, rest } = orderedPredicates.reduce(
            ({ sorted, rest }, predicate) => {
                const matchedItems = rest.filter((item) => predicate(item));

                return {
                    sorted: [...sorted, ...matchedItems.sort()],
                    rest: R.without(matchedItems, rest),
                };
            },
            {
                sorted: [],
                rest: items,
            },
        );

        return sorted.concat(rest);
    },

    clearNullable<T>(array: T[]) {
        return array.filter(Boolean) as Exclude<
            T,
            false | undefined | null | 0 | ''
        >[];
    },
};

const _convertVersionToFixed = (version) =>
    version
        .split('.')
        .map((n) => +n + 100000)
        .join('.');

const _convertVersionFromFixed = (version) =>
    version
        .split('.')
        .map((n) => +n - 100000)
        .join('.');
